// extracted by mini-css-extract-plugin
module.exports = {"dialog-container":"SusiLightDialog_dialog-container__6QprY","dialog-close-button":"SusiLightDialog_dialog-close-button__I7B2Y"};